module.exports = __webpack_public_path__ + "img/cog.488d87e9.svg";